<template>
  <div class="dropdown-footer">
    <slot />
  </div>
</template>

<style lang="scss">
@use './DropdownFooter.scss';
</style>
